export const searchProductsWithMetricsDataParams =  /* GraphQL */ `{
  term: $term,
  sort: $sort,
  metric_data: {
    search_id: $search_id,
    search_context: $search_context,
    new_buyer: $new_buyer,
    user_id: $user_id,
    browser_id: $browser_id
  },
  filters: {
    department: $department,
    sub_categories: $sub_categories,
    brands: $brands,
    brands_quantity: $brands_quantity,
    size_types: $size_types,
    price_max: $price_max,
    price_min: $price_min,
    used: $used,
    shipping_range: $shipping_range,
    city: $city,
    state: $state,
    promotion_slug: $promotion_slug,
    seller_segmentation: $seller_segmentation,
    last_published_at: $last_published_at,
    published_before: $published_before,
    exposure: $exposure,
    experienced_seller: $experienced_seller,
    discount_percentage_min: $discount_percentage_min,
    discount_percentage_max: $discount_percentage_max,
    store_kind: $store_kind,
    plan_id: $plan_id
  }
}`
